let chatsCollection = "chatsTest";
let userChatsCollection = "userChatsTest";


export { chatsCollection, userChatsCollection };